<!--
 * @Author: your name
 * @Date: 2022-03-31 16:47:59
 * @LastEditTime: 2022-06-01 14:49:43
 * @LastEditors: Jokersora 674077946@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\Service.vue
-->
<template>
  <div class="service">
    <div class="para">
      <div class="tit">主营业务范围</div>
      <div class="txt">
      承接各类建筑机电安装工程、消防工程、建筑装饰装修工程、电子与智能化系统工程、暖通中央空调工程、专业深耕洁净无尘室行业：主要采用EPC模式，对生物医药、半导体、电子、食品、室验和检测室、新型材料等净化行业，从设计、施工到维保提供全产业链服务，工艺、废气废水处理系统安装、压缩空气和气体供应系统安装、化工医药行业特种设备及压力管道工程、医院手术室净化及医用气体工程安装、污水处理设备及管道安装、环保设备及管道安装。 
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">洁净无尘系统净化工程</div>
      <div class="imgs">
        <div v-for="i in 6" :class="i>=5?'w':''" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'no' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">建筑机电安装工程</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'ele' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">消防工程</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'fire' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">建筑装饰装修工程</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'dec' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">电子与智能化系统工程</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'auto' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    
    <div class="para">
      <div class="tit tit1">暖通中央空调工程</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'air' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    
    <div class="para">
      <div class="tit tit1">化工医药行业特种设备及压力管道工程</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'pip' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">污水处理设备及管道安装、环保设备及管道安装</div>
      <div class="imgs">
        <div v-for="i in 4" :key="'ele-'+i" :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'po' + i + '.jpg') + ')',
            }">
        </div>
      </div>
    </div>
    <Root />
  </div>
</template>

<script>
import Root from "@/components/Root.vue";
export default {
  name: "Service",
  components: {
    Root,
  },
};
</script>

<style lang="less" scoped>
.para {
  padding: 1rem 20% 1rem 20%;
  display: inline-block;
  width:100%;
}
.tit {
  font-size: 1.5rem;
  color: rgb(27, 151, 243);
  border-left: 5px solid rgb(27, 151, 243);
  padding-left: 0.5rem;
  font-weight: bold;
  text-align: left;
}
.tit1{
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
}
.txt {
  color: rgb(100, 100, 100);
  font-size: 0.9rem;
  line-height: 2rem;
  padding-top: 1rem;
  text-align: left;
}
.imgs{
    width:100%;
}
.imgs>div{
    width:calc(50% - 0.2rem);
    margin:0.1rem;
    height:20rem;
    display: inline-block;
}
.imgs>div.w{
  width:100%;
}
</style>